import styled from 'styled-components'

import theme from 'theme_'
import { H1 } from 'components/Typography/Headings'

const statuses: { [char: string]: any } = {
  inactive: {
    background: `rgba(255, 77, 77, .15)`,
    borderColor: 'rgba(255, 77, 77, .25)',
    color: 'rgb(255, 77, 77)',
  },
  active: {
    background: 'rgba(35, 197, 20, .15)',
    borderColor: 'rgba(35, 197, 20, .25)',
    color: theme.colors.successGreen,
  },
  warning: {
    background: 'rgba(243, 223, 45, .15)',
    borderColor: 'rgba(243, 223, 45, .25)',
    color: theme.colors.statusYellow,
  },
}

export const StatusCardsWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 32px;
  gap: 16px;
  display: grid;
  grid-template-columns: repeat(auto-fill, 250px);
`

export const StatusCardWrapper = styled.div<{
  status: string
  isLoading?: boolean
}>`
  background: ${({ status }) => statuses[status].background};
  border-color: ${({ status }) => statuses[status].borderColor};
  color: ${({ status }) => statuses[status].color};
  padding: 16px;
  min-height: 186px;
  flex-grow: 1;
  flex-basis: 0;
  border-radius: 8px;
  border-style: solid;
  border-width: 1px;
  display: flex;
  flex-direction: column;
`

export const StatusCardHeader = styled(H1)`
  display: flex;
  color: ${theme.colors.duneWarmGrey};
  align-items: center;
  gap: 16px;
`
export const StatusCardHeaderWrapper = styled.div`
  margin-bottom: 16px;
  position: relative;
`

export const StatusCardBody = styled.div`
  height: 100%;
  color: initial;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const StatusWrapper = styled.div`
  padding-left: 6px;
  display: flex;
  align-items: center;
  font-weight: bold;
  gap: 14px;
  color: ${theme.colors.duneWarmGrey};
`

export const ConnectionWrapper = styled.div`
  padding-left: 6px;
  display: flex;
  align-items: center;
  gap: 14px;
`

export const ErrorText = styled.div<{
  color: string
}>`
  color: ${({ color }) => color};
`

export const ModuleTable = styled.table`
  text-align: left;
  font-size: 14px;
  width: 100%;
  border-spacing: 0 32px;
  & th {
    font-weight: normal;
  }

  & td {
    @media ${theme.devices.mobile} {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }
`

export const DetailsWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`
